module.exports = __webpack_public_path__ + "img/cnc-03-greenery-open-space.7cc301fd.svg";